:host {
  display: block;
  width: 100%;
}

 .kt-subheader__main {
  display: flex
  ;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      padding: 0.25rem 0;
  }


  .kt-subheader__breadcrumbs {
    display: flex
;
    align-items: center;
    list-style-type: none;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
}
.kt-subheader__breadcrumbs-link {
    padding: 0 0.5rem 0 0;
    font-size: 1rem;
    font-weight: 500;
    color: #6f6f6f;
    transition: all 0.3s;
    text-decoration:none;
}

.kt-subheader__breadcrumbs-link {
    color: #6f6f6f;
}

 .kt-svg-icon.fav-icon {
    width: 17px;
    height: 17px;
    transform: scaleX(-1);
}

.kt-svg-icon.inactive {
    opacity: 0.35;
}
.kt-svg-icon g [fill] {
    fill: #008fc7;
}

.kt-subheader__breadcrumbs-separator:after {
    display: block;
    width: 1px;
    height: 16px;
    border-radius: 0;
    content: " ";
    background: #e7e8ef;
}
 .kt-subheader__breadcrumbs-separator:after {
    background: #dbdce7;
}

.kt-subheader__breadcrumbs-separator {
    display: flex
;
    justify-content: content;
    align-items: center;
    padding: 0 0.5rem 0 0;
}
 .kt-subheader__toolbar {
    display: flex
;
    justify-content: flex-end;
    align-items: center;
    padding: 0;
}

 .btn {
    display: inline-flex
;
    height: 32px !important;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.btn.btn-icon {
    width: 32px !important;
    align-items: center;
}
.btn:not(.dropdown-toggle-split) {
    margin-left: 0.5rem;
}
.btn:not(.dropdown-toggle-split) {
    margin-left: 0.25rem;
}
.kt-svg-icon.inactive {
    opacity: 0.35;
}

.kt-svg-icon {
    height: 23px;
    width: 23px;
}


.fav-cont {
  display: flex
;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
}

.kt-subheader__breadcrumbs-item:after {
  display: block;
  width: 1px;
  height: 16px;
  border-radius: 0;
  content: " ";
  background: #dbdce7;
  top:3px;
  right: 0;
}.kt-subheader__breadcrumbs-link {
  position: relative;
  display: inline-flex;
  justify-content: space-between;
}

.kt-subheader__breadcrumbs-item:after {
  top: 3px;
  position: absolute;
  right: 12px;
}.kt-subheader__breadcrumbs-link i {
  font-size: 14px;
}



span.kt-subheader__breadcrumbs-link.kt-subheader__breadcrumbs-item {
  padding-right: 20px;
}

input[type="text"] {
 
  border: 1px solid #e2e5ec;
  border-radius: 4px;
}



.kt-subheader__breadcrumbs-link:hover {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  color: #008fc7;
}
.kt-subheader__breadcrumbs-item:last-child:after {
  display: none;
}
.no-items{
  font-weight: bold
}

.toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 20px;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  z-index: 9999;
  animation: fadeInOut 3s ease-in-out;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.toast.success {
  background-color: #2ecc71;
}

.toast.error {
  background-color: #e74c3c;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }
  10% {
    opacity: 1;
    transform: translateY(0%);
  }
  90% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(-20%);
  }
}
